import Rails from 'rails-ujs';
import { Controller } from 'stimulus';

export default class extends Controller {
  chat_pin() {
    Rails.fire(this.scope.element.closest('form'), 'submit');
  }
}
